import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { currentCourseSelector } from '../Courses/selectors';
import { selectInstitution } from '../PortalAdmin/selectors';

export const selectPortalsByPath = (state) => state.Portals.get('byPath');

export const selectPortalByPathJS = (institutionPath) =>
  createSelector([selectPortalsByPath], (portalsByPath) =>
    portalsByPath.get(institutionPath, Immutable.Map()).toJS()
  );

export const selectCurrentPortalForInstitutionSetting = createSelector(
  [selectPortalsByPath, selectInstitution],
  (portalsByPath, currentQueryInstitution) =>
    portalsByPath.get(currentQueryInstitution, null)
      ? portalsByPath.get(currentQueryInstitution).toJS()
      : null
);

export const getCourseLinkedPortal = (course, portalsByPath) => {
  if (!course || !course.get('institution')) {
    return null;
  } else {
    return portalsByPath.get(course.get('institution'));
  }
};

export const selectCurrentCourseLinkedPortal = createSelector(
  [currentCourseSelector, selectPortalsByPath],
  (currentCourse, portalsByPath) => {
    return getCourseLinkedPortal(currentCourse, portalsByPath);
  }
);

export const getCourseLinkedPortalJS = (linkedPortal) => {
  return linkedPortal ? linkedPortal.toJS() : null;
};

export const selectCurrentCourseLinkedPortalJS = createSelector(
  selectCurrentCourseLinkedPortal,
  (linkedPortal) => getCourseLinkedPortalJS(linkedPortal)
);

export const selectCurrentCourseLinkedPortalIsEnabled = createSelector(
  selectCurrentCourseLinkedPortal,
  (linkedPortal) => {
    if (!linkedPortal) {
      return false;
    }

    return linkedPortal.get('identitySessionEnabled', false);
  }
);

export const selectDefaultPortal = createSelector(
  selectPortalsByPath,
  (portalsByPath) => {
    return portalsByPath.get('default', null);
  }
);

export const selectPortalLowCostEnabled = (portalPath) =>
  createSelector([selectPortalsByPath], (portals) =>
    portals.getIn([portalPath, 'lowCost'])
  );
